import dimbox from 'dimbox';
import { getCookie } from '../functions.js';
const cookieName = 'occ';

document.addEventListener('DOMContentLoaded', async () => {
    dimbox.setConfig({
        showDownloadButton: false,
        iframeTemplate: '<div class= "dimbox-iframe-container" ><iframe src="{{src}}" class="dimbox-iframe" allow="autoplay; encrypted-media" allowfullscreens></iframe><div class="dimbox-caption">{{caption}}</div></div>',
        inlineTemplate: `<div class="dimbox-inline-container"><div class="dimbox-inline-content">{{content}}</div></div>`
    });

    const $videoPopups = document.querySelectorAll('.video-popup');
    let videoPlayed = false;
    let cookieConsent = await getCookie(cookieName);

    if ($videoPopups) {
        dimbox.setConfig({
            onBeforeUpdateContent: function (currentEl) {
                let target = currentEl.dataset.inlineTarget;
                let youtubeId = currentEl.dataset.youtubeId;
                if (youtubeId) {
                    if (cookieConsent === 'allcookies') {
                        videoPlayed = true;
                    } else {
                        let $modal = document.getElementById(target.replace('#', ''));
                        let $videoLink = $modal.querySelector('a');
                        $videoLink.href = `https://www.youtube.com/watch?v=${youtubeId}`;
                    }
                }
            }
        });
    }

    $videoPopups.forEach($videoPopup => {
        let videohref = $videoPopup.dataset.href;
        let warninghref = $videoPopup.dataset.inlineTarget;
        $videoPopup.href = cookieConsent === 'allcookies' ? videohref : warninghref;
    });

    cookieStore.addEventListener('change', async ({ changed, deleted }) => {
        const occChanged = changed.find(c => c.name === cookieName);
        const occDeleted = deleted.find(c => c.name === cookieName);

        if (occChanged || occDeleted) {
            cookieConsent = occChanged?.value === 'allcookies';
            $videoPopups.forEach($videoPopup => {
                let videohref = $videoPopup.dataset.href;
                let warninghref = $videoPopup.dataset.inlineTarget;
                $videoPopup.href = cookieConsent ? videohref : warninghref;
            });
            if (!cookieConsent && videoPlayed) window.location.reload();
        }
    });
});